export default "__VITE_ASSET__cd474ecd__"